
import { computed, defineComponent } from 'vue'
export default defineComponent({
  name: 'navMenuSubItem',
  props: {
    chil: {
      type: Array,
      default: () => []
    }
  },
  setup (props) {
    // 获取父级菜单数据
    const chils = computed(() => {
      return props.chil
    })
    return {
      chils
    }
  }
})
